/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SubscriptionTypeEnum = 'COMMIT' | 'ONDEMAND';

export const SubscriptionTypeEnum = {

    COMMIT: 'COMMIT' as SubscriptionTypeEnum,

    ONDEMAND: 'ONDEMAND' as SubscriptionTypeEnum
};

